// extracted by mini-css-extract-plugin
module.exports = {"container":"Xr","productName":"Yr","modal":"Zr","dimensions":"_r","recipientEmail":"as","lowStock":"bs","recommendedFit":"cs"};